import { Component, OnInit, EventEmitter, Output, HostListener } from '@angular/core';
import { Observable, timer, Subscription } from 'rxjs';

import { ApiCallerService } from '../services/api-caller.service';
import { AngularFireDatabase} from 'angularfire2/database';


@Component({
  selector: 'app-student-quiz-view',
  templateUrl: './student-quiz-view.component.html',
  styleUrls: ['./student-quiz-view.component.css']
})
export class StudentQuizViewComponent implements OnInit {

  @Output() startHistorical = new EventEmitter();
  @Output() exitHistorical = new EventEmitter();
  @Output() stopStudentQuiz = new EventEmitter();

  question = "";
  description = "";
  quizOn = false;
  showStatus = false;
  public currentTrack = "";

  public finalQuestion = false;

  actionSub: Subscription;
  questionSub: Subscription;
  public currentQuestion = 0;

  @HostListener('window:beforeunload', [ '$event' ])
    beforeUnloadHander(event) {
      this.db.list('/Session-'+this.service.sessionId + "/disconnected").push("1");
      
    }

  answer(event){
  	this.description = "Ditt svar är registrerat. Snart kommer läraren visa vad klassen svarat.";	
  	this.quizOn = false;
    this.showStatus = true;
    this.service.myAnswers[this.service.currentQuestion] = event;



    this.db.list('/Session-'+this.service.sessionId + "/answer").push({"question": this.service.currentQuestion, "answer": event, "track" : this.service.selectedTrack[0]});

    this.db.list('/Session-'+this.service.sessionId + "/currentAnswer").push(1);

  }

  countDown(event){
  	if (event.action == "done") {
  	this.description = "Ooops! Tiden tog slut innan du hann svara. Ingen fara, du hinner nog svara på nästa fråga istället.";	
  	this.quizOn = false;
    this.showStatus = true;
  }

}



	constructor(
		private service: ApiCallerService,
		private db: AngularFireDatabase) { }


  ngOnDestroy() {
    this.actionSub.unsubscribe();
    this.questionSub.unsubscribe();
  }

  ngOnInit() {

  // Hämta track id
    this.db.list('/Session-'+this.service.sessionId + "/track").valueChanges().subscribe((track : any) => {
          this.currentTrack = track;
          this.service.selectedTrack = track;
          this.question = this.service.quizQuestions[this.currentTrack][this.service.currentQuestion];

      });



    this.questionSub = this.db.list('/Session-'+this.service.sessionId + "/question").valueChanges().subscribe((question: any) => {
      this.service.currentQuestion = question;
      this.question = this.service.quizQuestions[this.service.selectedTrack][this.service.currentQuestion];

      this.currentQuestion = question;
    });


    this.actionSub = this.db.list('/Session-'+this.service.sessionId + "/action").valueChanges().subscribe((action: any) => {


      if (action.length == 0) {
        return;
      }
      if (action == "reset" ) {
        this.stopStudentQuiz.emit();
      }
      if (action == "start") {
        
        this.quizOn = true;
      }
      if (action == "text"){
        this.exitHistorical.emit(1);
      }
      if (action == "historical"){
        this.service.currentQuestion++;
        this.startHistorical.emit();
      }

      if (action == "next" || action == "previous"){
        this.quizOn = false;
        this.showStatus = false;
      }



    });

    return;



  }

}
